import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import { navigate } from 'utils/navigate';
import { URLS } from 'utils/urls';

export function EditButton({ contentId }: { contentId: string | undefined }) {
  if (!contentId) {
    return null;
  }

  const openEditor = () => {
    navigate(URLS.editByContentId(contentId));
  };

  return (
    <IconButton aria-label="Edit" onClick={openEditor}>
      <EditIcon color="primary" />
    </IconButton>
  );
}
